import styled from "styled-components";
import { IconButton } from "../../components";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { FiltersAppliedWarningMessage, PageSubHeader, ThemedIcon } from "../../components/utilities";
import Wp3Dropdown from "../../components/utilities/Dropdown";
import { useFilterContext } from "../../hooks/FilterContext";
import { AdviceRegisterFiltersModal, AdviceRegisterTableHeader, AdviceRegisterTableRow } from "./components";
import useAdviceRegister from "./hooks/useAdviceRegister";

const FilterHeader = styled(PageSubHeader)`
    padding: 0.75rem;
`

const AdviceRegister = () => {

    const {
        clear,
        data,
        error,
        isClearing,
        isRowLoaded,
        loadMore,
        currentSort,
        sortTable,
        totalCount,
        exportCsv
    } = useAdviceRegister();
    const { setShowFilterModal, isFiltersApplied, clearFilter } = useFilterContext();

    // const { filter, defaultFilters, isFiltersApplied, clearFilter, setFilter } = useFilterContext();

    // const onFilterButtonClicked = () => openAdviceRegisterFiltersModal(filtersToForm(filter), filtersToForm(defaultFilters))
    //     .then(form => setFilter(formToFilters(form)));

    return <>
        <AdviceRegisterFiltersModal />
        <FilterHeader>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    {isFiltersApplied && (
                        <>
                            <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                            <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                Warning - Filters are currently being applied to your results.
                                <br />
                                <button className="anchor" onClick={clearFilter}>Click here</button> to clear your filters.
                            </FiltersAppliedWarningMessage>
                        </>
                    )}
                </div>
                <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                    <IconButton
                        icon={['fas', 'filter']}
                        onClick={() => setShowFilterModal(true)}
                        menu={[
                            <Wp3Dropdown.Menu>
                                <Wp3Dropdown.MenuItem icon={['fas', 'download']} text="Export Register" onClick={exportCsv} />
                            </Wp3Dropdown.Menu>
                        ]}
                    >
                        Filter Register
                    </IconButton>
                </div>
            </div>
        </FilterHeader>
        <section className="h-100 px-4 my-3">
            <VirtualTable
                enableScrollTracking
                row={AdviceRegisterTableRow}
                header={<AdviceRegisterTableHeader currentSort={currentSort} sortTable={sortTable} />}
                footer={(
                    <TableRecordCountDisplayFooter
                        spanLeft={10}
                        totalCount={totalCount}
                        reload={clear}
                    />
                )}
                isLoading={isClearing}
                error={error}
                isItemLoaded={isRowLoaded}
                loadMoreItems={loadMore}
                itemSize={60}
                itemCount={totalCount}
                itemData={data}
            />
        </section>
    </>
}

export default AdviceRegister;